import styles from "./Loader.module.css";
const Loader = (props) => <div className={styles.loaderContainer}><div {...props} className={styles.loader}></div></div>
export default Loader